var _defs, _style, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: 21,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 21,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVAQMAAACT2TfVAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAA9JREFUeJxjZGBgYKQyBgAD8AAW6TVEVAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 21,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAAXNSR0IB2cksfwAAARpQTFRFAAAAKSIcLCMdLCQeLSQeKyQdLCQeLCUfKysrLSUfLCQeLCQeLCQeLCQeLyIbICAgLCQeLCQeJCQkLSQeLCQeKyAgLCQeLiQfAAAAKyUdLCQeKyIeKyQdLCQeKyQeLCEhLCQeLSUdLCQdLSQeMyIiLCQeKyIiLSQeLCQeLCQfLSMeLCUdLSQeLCQeLCQeLCQeLSQeJycnLSQeLCMeLCQeLCQeLCQeLCQeLCQeKyQeKyMfLCQfLCMeLCQeLiQgLCUfLSQfLSYgKyMeLCMeLCEcLCQeLCUeLCUfLCQfLCQeLCQeLCMfLCQeLSQfLCQeMxoaQEAALCMeLCQeLCQeLSQeVQAAAAAALCQeLSQeKiQfKyUfKyUeLCQeLCQewySyDAAAAF50Uk5TACV7uL2lhksGWs3/9KMmCKraDprwGPIyAVmAPEfeKhfGYSOxD/4eq+9jM4uP3fbPeA3OmOKszNy6gUGetPk4Urcon+Yu/W+EYsFcUaI57AoEkcn7fgMCqFUxfJn80k0SyckAAAESSURBVHicY2QAAUYo+MEAAYxAzMnIyACT/AQV5Wf8zQADbIzvoKLCP+CCnG//QzWJfoMLcjO+ZJAAmvKUgVHmPUxQiPERgzzjawYGsfuMSi+hghKMdxgYuED2SgFtV38CEpNlvA4ktR6CFSgwMqhwgJ16HsQ1uA0WVWdkQAbGN8CUJqqo6TUwpc1ofkudkfHqR4io8gswZcBoAzLQ6D/TISRRE0aoBQymjPsZGJxOgpgWRxldjkPNtGLcxeB+BMSy3cHI4HkIZpf9Nu8DQMpxCzB0fPfBRJ0ZjwEDRUJ3Ayh8A3fBnXsoCOif1eBQD2PcAhU12x/BuBwSvkAQ9XMHiDI8AtME8Rtj1CV9xu+/N8JEAbgaPYV5r0kIAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img2",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRaw);
export default __webpack_public_path__ + "static/media/logo-raw.566b8439d9a5f20b2bccfdbe84e1a012.svg";
export { ForwardRef as ReactComponent };